export default class BaseCollection {
  models = []
}
